import React from 'react';

import { FormProvider } from 'components/Forms/InvestmentTransactionEditForm/investmentTransactionEditFormHooks';

import { useInvestmentTransactionEditForm } from '../hooks/useInvestmentTransactionEditForm';
import type { InvestmentTransactionEditDialogProps } from '../types';
import InvestmentTransactionEditDialogView from './InvestmentTransactionEditDialogView';

export default function InvestmentTransactionEditFormProvider(
  props: InvestmentTransactionEditDialogProps,
): React.JSX.Element {
  const { formInput, onSubmit, transaction } = useInvestmentTransactionEditForm(props);

  return (
    <FormProvider input={formInput} onSubmit={onSubmit}>
      <InvestmentTransactionEditDialogView {...props} transaction={transaction} />
    </FormProvider>
  );
}
